export default __webpack_public_path__ + "static/advance-technical-50316dc58d329d070798efe11c6de143.jpg";